

// function click1()
// {
//   if (trial==0){toggleZoomScreen(100);}//zoom to 100% in IE, Chrome, Safari}
//   switch (screenType)
//   {
//     case "consent":
//       endConsent();
//       break;
//     case "calibration":
//       endCalibrate();
//       break;
//     case "pdetails":
//       endPdetails();
//       break;
//     case "general":
//       endGeneral();
//       break;

//     default:
//       hideAll();

//       if (listArrays[allColumns.indexOf('test')][trialRow]=="CFPT"){
//         sortNext();
//         clearTimeouts();

//         saveTrial(CFPTerror);/// should save the number of errors here for the CFPT
//       }
//       else {
//         saveTrial("1");
//       }

//       clearTimeouts();
//       endTrial();

//   }

// }

var lastKey, lastClick, lastRTTimestamp;

function clickButton1()
{
  if (trial==0){toggleZoomScreen(100);}//zoom to 100% in IE, Chrome, Safari}

  switch (screenType)
  {
    case "consent":
      endConsent();
      break;
    case "fullscreen":
      enterFullScreen();
      break;
    case "calibration":
      endCalibrate();
      break;
    case "pdetails":
      endPdetails();
      break;
    case "general":
      endGeneral();
      break;
    case "enableMediaAutoPlay":
      enableMediaAutoPlay();
      break;

    default:
      if (listArrays[allColumns.indexOf('test')][trialRow]=="CFPT"){
        window.sortCFPT !== undefined && window.sortCFPT.option('disabled',true);
        hideAll();
        sortNext();
        clearTimeouts();
        saveTrialCFPT(CFPTerror,finalOrder);/// should save the number of errors here for the CFPT
        clearTimeouts();
        endTrial();
      }
      else {
        clickButton("1");
      }
  }
}

function autoAdvance() {
  if (window.endRecordingMicResponse) {
    return;
  }

  if(window.columnForTrial('type', window.trialRow) == 'learn'){
    window.saveLearnTrial();
  }

  clearTimeouts();
  endTrial(true);
}

function clickButton2(){clickButton("2");}
function clickButton3(){clickButton("3");}
function clickButton4(){clickButton("4");}
function clickButton5(){clickButton("5");}
function clickButton6(){clickButton("6");}
function clickButton7(){clickButton("7");}
function clickButton8(){clickButton("8");}
function clickButton9(){clickButton("9");}
function clickButton10(){clickButton("10");}
function clickButton11(){clickButton("11");}
function clickButton12(){clickButton("12");}


function clickButton(buttonNumber) {
  var response = buttonNumber;

  if(window.feedbackScreen){
    clickGeneral();
    window.cleanFeedback();
    return;
  }

  if (hasCustomInputsVisible()) {
      if ($('#responseBox:visible').length) {
        response = $('#responseBox:visible').val() + ';' + buttonNumber;
      } else if ($('#responseComment:visible').length) {
         response = $('#responseComment:visible').val() + ';' + buttonNumber;
         clickResponseComment(false);
      } else if ($('#responseContainer:visible #slider1').length) {
        response = getSliderValues() + ';' + buttonNumber;
        clickSlider(false);
      } else if($('.clicked').length || columnForTrial('responseType', trialRow) == "clicks") {
        response = 0;
        for(var i = 1; i <= listNoStim[trialRow] + listNoStimS2[trialRow]; i++){
          if($(stimContainers[i]).hasClass('clicked')){
            response = i;
            break;
          }
        }
        if(response == 0){
          return;
        }
      }
  } else {
    if (trialHasClicksEnabled()) {
        response = window.clickResponseValue  + ';' + buttonNumber;
      }
  }

  window.currentResponseText = buttonsContainers[buttonNumber].innerText;

  clickGeneral(response);
}

function getSliderValues() {
  var values = [];

  $('#responseContainer:visible .sliderInput').each(function() {
    values.push(this.value);
  });

  return values.join(';');
}

function clickStim(event, el, stimNumber) {
  var isClickable = $(el).hasClass('clickableImage');
  var clickResponseExactValue = null;

  if (isClickable) {
    window.lastClick = stimNumber;
    window.clickResponseValue = stimNumber;

    if (hasClicksOptions()) {
      var clickRelativePosition = computeClickRelativePosition(event, el, listTrialResponseOptions[window.trialRow]);
      window.clickResponseValue = computeClickResponse(stimNumber, clickRelativePosition);

      if (clickRelativePosition.exact) {
        clickResponseExactValue = computeClickExactResponse(stimNumber, clickRelativePosition);
      }

      $(document).trigger(window.events.stimClick, event);
    } else {
      //wihtout options, then we have entire stim clickable
      markClickedEntireStim(el);
    }

    //if we have buttons, then do not advance
    if (!trialHasButtonsActive(trialRow) && window.minimumResponseWindowEnded) {
      disableClickOnImages();
      window.currentResponseText = el.dataset.stimName;
      if (hasClicksOptions()) {
        //when we have click options, delay the end of trial so we would have a visual feedback for the user
        setTimeout(function() {
          clickGeneral(window.clickResponseValue, clickResponseExactValue);
        }, 100);
      } else {
        clickGeneral(window.clickResponseValue);
      }
    }
  }
}


function click0(){clickGeneral("0");}
function clickN(n){
  if(enableClicks[trialRow]){
    clickGeneral(n);
  }
}
function click1() {
  if(enableClicks[trialRow]){clickGeneral("1");}
}
function click2(){if(enableClicks[trialRow]){clickGeneral("2");}}
function click3(){if(enableClicks[trialRow]){clickGeneral("3");}}
function click4(){if(enableClicks[trialRow]){clickGeneral("4");}}
function click5(){if(enableClicks[trialRow]){clickGeneral("5");}}
function click6(){if(enableClicks[trialRow]){clickGeneral("6");}}

function click99(){
  if (recordRTkeys==1){
    responseBox.value = responseBox.value + ';timeout';
    clickResponse();
  }
  else {
    //gets called when response times out, maybe replace with a better response to avoid collision.
    clickGeneral("999");
  }
}

function savePartialResponse(suffix) {
  const defaultTimeoutValue = 'timeout';

  if (!suffix) {
    suffix = defaultTimeoutValue;
  }

  const responseType = columnForTrial('responseType', trialRow);
  const responseWindow = listTrialResponseWindow[trialRow].timeout;
  var finalResponse = suffix;

  if(columnForTrial('type', trialRow) === 'form'){
    validateFormTrials();
    return;
  }
  else if(responseType.indexOf('box') > -1){
    const boxResponse = window.getResponseBoxesResponse();
    if (boxResponse) {
      finalResponse = boxResponse + ';' + suffix;
    }
  }
  else if(responseType == 'comment' && responseComment.value){
    finalResponse = responseComment.value + ';' + suffix;
  }
  else if(hasMultipleClicks() && window.clickedImages.length > 0){
    window.RTkeys_trial = window.clickedStimuliRTs.join(';');
    finalResponse = window.clickedImages.join(';') + ';' + suffix;
    window.clearMultipleClicksSelection(window.trialRow);
  }
  else if(responseType == 'slider') {
    finalResponse = getSliderValues() + ';' + suffix;
  }
  else if(responseType == 'label') {
    finalResponse = getLabelResponses() + ';' + suffix;
  }
  else if(responseType == 'sort') {
    finalResponse = getSortableResponse() + ';' + suffix;
  }
  else if(responseType == 'mic') {
    // checking that the function exists is just an extra measure to prevent errors, just in case it doesn't exist as it is dynamically created
    if (window.endRecordingMicResponse) {
      window.endRecordingMicResponse();
      return;
    }
  }
  else if(window.keysTrial != null){
    finalResponse = window.keysTrial + ';' + suffix;
  }

  saveTrial(finalResponse);
}

function responseDefaultOnTimeout() {
  savePartialResponse();
}

function clickResponse() {
  saveTrial(responseBox.value);
  clearTimeouts();
  endTrial();
}

function clickResponseComment(shouldNotEnd)
{
  if (document.getElementById("responseComment").required==false || document.getElementById('responseComment').value.trim()!='')
  {
    shouldNotEnd !== false && saveTrial(responseComment.value);
    document.getElementById('responseComment').value='';
    document.getElementById('responseComment').style.display='none';
    document.getElementById('characters').style.display='none';
    $('#characters').text('');
    document.getElementById('buttonComment').style.display='none';
    shouldNotEnd !== false && clearTimeouts();
    shouldNotEnd !== false && endTrial();
  }
}
function clickSlider(shouldNotEnd, responseTimestamp)
{
  var inputFieldValue = getSliderValues();

  var slider = $('#' + 'slider1').data("ionRangeSlider");

  var sliderResponseCode = slider.old_from;


  if($(slider.input).attr('data-values')){
    sliderResponseCode++;
  }

  // this makes slider value 'na' if slider wasn't touched commenting it until we change this again
  if($('#slider1').data('touched') !== true && columnForTrial('responseOptions', trialRow).indexOf('hideStart') >= 0){
    sliderResponseCode = 'na';
    inputFieldValue = 'na';
  }

  $('#responseContainer').empty();
  if (shouldNotEnd !== false) {
    if(columnForTrial('type', trialRow) != 'practice'){
      responseCodes.push(sliderResponseCode);
      window.rowResponseCodes[window.trialRow] = sliderResponseCode;
      window.allResponseCodes.push(sliderResponseCode);
    }
    saveTrial(inputFieldValue, null, responseTimestamp);
    clearTimeouts();
    endTrial();
  }
}
function pressKey(keyPressed) {

  window.lastKey = keyPressed;
  window.lastRTTimestamp = performance.now();
  // multiple key responses
  var trialOptions = window.listTrialResponseOptions[window.trialRow] || {};
  var shouldRecordMultipleKeys = Boolean(trialOptions.multipleResponses);

  // if we need to record multiple keys, then save them, and don't move to next trial only if max keys recorded reached
  if (shouldRecordMultipleKeys && window.trialKeysPressedCounter <=  trialOptions.multipleResponses.max) {
    if($('#submitMultipleKeys').length == 0){
      setResponseTopPosition();
      var top = currentButtonTop || buttonTopDefault;
      var submitButton = '<button id="submitMultipleKeys" class="btn btn-primary" type="button" style="display:none;font-size:180%;margin-left:auto;margin-right:auto;margin-top:' + top + 'px;" onclick="nextTrialWithKeys(window.keysTrial)">Confirm</button>';
      $('#displayScreen').append(submitButton);
    }

    window.keysTrial = window.keysTrial === null ? keyPressed : window.keysTrial + ';' + keyPressed;
    window.recordRTkeys = 1;
    recordMultipleRT();
    window.trialKeysPressedCounter += 1;
    const hasMinResponses = window.trialKeysPressedCounter >=  trialOptions.multipleResponses.min;
    var hasFinishedPresentation = trialOptions.multipleResponses.presentationFinished;
    if(columnForTrial('ISI', window.trialRow) == 'na' && columnForTrial('presTime', window.trialRow) == 'na' && window.listStimType[window.trialRow] != 4){
      hasFinishedPresentation = true;
    }

    // we have the minimum responses required and the presentation has ended
    var canAnswerMore = window.trialKeysPressedCounter <  trialOptions.multipleResponses.max;

    if(hasMinResponses && canAnswerMore){
      $('#submitMultipleKeys').css('display','block');
    }

    if (canAnswerMore) {
      return;
    }
  }

  if (window.hasMinimumResponseWindow() && !window.minimumResponseWindowEnded){
    return;
  }

  var response = window.keysTrial ? window.keysTrial : keyPressed;
  // end multiple key responses

  nextTrialWithKeys(response);
}

function nextTrialWithKeys(response, extra, responseTimestamp) {
  $('#submitMultipleKeys').remove();
  saveTrial(response, extra, responseTimestamp);
  clearTimeouts();
  endTrial();
}
// responseTimestamp - optional parameter, it overrides the current timestamp for response
function clickGeneral(response, extra, responseTimestamp)
{
  if(window.minimumResponseWindowEnded){
    saveTrial(response, extra, responseTimestamp);
    clearTimeouts();
    endTrial();
  }
  else{
    window.lastClick = response;
    window.lastRTTimestamp = performance.now();
  }
}

function clickButtonForm()
{
  var iframe = document.getElementById('formFrame');
  var innerDoc = iframe.contentDocument || iframe.contentWindow.document;

  var responseQ = [];
  for (iQ=1; iQ<listNoFormQ[trialRow]+1; iQ++)//go question by question
    {
      switch (formArray[trialRow][iQ]["type"])
      {
        case "input":
          responseQ[iQ-1] = innerDoc.getElementById(trialRow+"formQ"+iQ).value;
          break;
        case "textarea":
          responseQ[iQ-1] = innerDoc.getElementById(trialRow+"formQ"+iQ).value;
          break;
        case "checkbox":
          var count;
          var tempResponse='';
          for(count in formArray[trialRow][iQ]["values"])
          {
            if (innerDoc.getElementById(trialRow+"formQ"+iQ+"count"+count).checked) {tempResponse = tempResponse + innerDoc.getElementById(trialRow+"formQ"+iQ+"count"+count).value;}
          }
          responseQ[iQ-1]=tempResponse;
          break;
        case "radio":
          var count;
          for(count in formArray[trialRow][iQ]["values"])
          {
            if (innerDoc.getElementById(trialRow+"formQ"+iQ+"count"+count).checked) {responseQ[iQ-1] = innerDoc.getElementById(trialRow+"formQ"+iQ+"count"+count).value;}
          }
          break;
        case "dropdown":
          responseQ[iQ-1] = innerDoc.getElementById(trialRow+"formQ"+iQ).value;
          break;
      }

    }

    console.log(responseQ);
    response = responseQ.join(";");

  saveTrial(response);
  clearTimeouts();
  endTrial();
}

function next()
{
  if (trial==-1){endPdetails();}
  else {main();}
}

// records key presses as responses
function check(e) {
  // ignore key pressed (this was added for multiplayer chat)
  if (window.preventResponseKeyboard || !window.keyReleased) {
    return;
  }

  window.keyReleased = 0;

  var key_code = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
  var keyboardColumn = columnForTrial('keyboard', trialRow);

  if (!keyboardColumn || !recordKeys) {
    return;
  }

  keyboardColumn = keyboardColumn.toLowerCase();

  var canPressAnyKey = false;
  if(keyboardColumn.indexOf("all") > -1){
    canPressAnyKey = true;
  }

  var specialKeysRegex = /escape|left|right|up|down|enter|space/gm;
  var specialKeys = false;

  if(keyboardColumn.match(specialKeysRegex)){
    specialKeys = true;
  }

  if(window.keysObject === undefined){
    window.keysObject = {
      37: 'left',
      38: 'up',
      39: 'right',
      40: 'down',
      27: 'escape',
      32: 'space',
      13: 'enter',
      48: '0', 96: '0',
      49: '1', 97: '1',
      50: '2', 98: '2',
      51: '3', 99: '3',
      52: '4', 100: '4',
      53: '5', 101: '5',
      54: '6', 102: '6',
      55: '7', 103: '7',
      56: '8', 104: '8',
      57: '9', 105: '9',
    }

    for (var upperCharCode = 65; upperCharCode <= 90; upperCharCode++) {
      var lowerCharCode = upperCharCode + 32;
      var lowerChar = String.fromCharCode(lowerCharCode);
      window.keysObject[lowerCharCode] = lowerChar;
      window.keysObject[upperCharCode] = lowerChar;
    }
  }

  if (keyboardColumn.indexOf(keysObject[key_code]) > - 1 || canPressAnyKey){
    if(specialKeys && keysObject[key_code].length == 1){
      var pressedKey = keysObject[key_code];
      var regexString = "( |^)" + pressedKey + "( |$)";
      var regexSeparatedKey = new RegExp(regexString, 'i');
      var match = regexSeparatedKey.exec(keyboardColumn);
      if(match === null){
        return;
      } else {
        return pressKey(pressedKey);
      }
    }
    if(keysObject[key_code]){
      pressKey(keysObject[key_code]);
    }
  }
}

function releaseKey(){
  window.keyReleased = 1;
}


//returns click position relative to element
function clickPositionInElement(e, el) {
  const clickPosition = clickPositionInElementOld(e, el);
  clickPosition.top = Math.round(clickPosition.top / window.adjuster);
  clickPosition.left = Math.round(clickPosition.left / window.adjuster);

  return clickPosition;

  function clickPositionInElementOld(e, el) {
    var clickPosition = {
      top: 0,
      left: 0
    }

    if (e.offsetX && e.offsetY) {
      clickPosition.left = e.offsetX;
      clickPosition.top = e.offsetY;
      
      return clickPosition;
    }

    var elPosition = $(el).offset();
    clickPosition.left = event.pageX - elPosition.left;
    clickPosition.top = event.pageY - elPosition.top;

    var leftBorder = parseInt($(el).css('border-left'));
    if (leftBorder) {
      clickPosition.left -= leftBorder;
    }

    var topBorder = parseInt($(el).css('border-top'));
    if (topBorder) {
      clickPosition.top -= topBorder;
    }

    return clickPosition;
  }
}

function computeClickRelativePosition(e, el, options) {
  var clickPosition = clickPositionInElement(e, el);

  if(options.origin) {
    const elHeight = el.clientHeight / window.adjuster;
    const elWidth = el.clientWidth / window.adjuster;

    switch (options.origin) {
      case 'center':
        clickPosition.top -=elHeight/2;
        clickPosition.left -=elWidth/2;
        break;
      case 'topright':
        clickPosition.left -=elWidth;
        break;
      case 'bottomleft':
        clickPosition.top -=elHeight;
        break;
      case 'bottomright':
        clickPosition.top -=elHeight;
        clickPosition.left -=elWidth;
        break;
    }

    clickPosition.left = Math.round(clickPosition.left);
    clickPosition.top = Math.round(clickPosition.top);

  } 
  
  if (options.grid && options.grid.rows && options.grid.cols) {
      clickPosition.exact = {left: clickPosition.left, top: clickPosition.top};
      clickPosition.top = Math.ceil(clickPosition.top * window.adjuster / ($(el).innerHeight() / options.grid.rows));
      clickPosition.left = Math.ceil(clickPosition.left * window.adjuster / ($(el).innerWidth() / options.grid.cols));
  }
  return clickPosition;
}

function computeClickResponse(stimNumber, clickRelativePosition) {
  return stimNumber + "_" + clickRelativePosition.top + "x" + clickRelativePosition.left;
}

function computeClickExactResponse(stimNumber, clickRelativeExactPosition) {
  return stimNumber + "_" + clickRelativeExactPosition.exact.left + "x" + clickRelativeExactPosition.exact.top;
}

function hasResponse(){
  return window.savedResponseThisTrial;
}